export enum STORE {
	RESET = 'STORE_RESET'
}

export type IStoreAction = {
	type: STORE
}
